import React from "react"

import { Wrapper, Row, ColWithBg, Content } from "../pageElements"

export const Banner = () => {
  return (
    <Wrapper>
      <Row height="screen">
        <ColWithBg>
          <Content center>BANNER</Content>
        </ColWithBg>
      </Row>
    </Wrapper>
  )
}
